﻿export type FiqassistApiURL = string;
export type AuthenticationApiURL = string;
export type FiqassistVersion = string;
export type SeqURL = string;
export class ConversationSettings {
    PeriodiclyCheckForChanges: boolean = true;
    PeriodsWithNoChanges: number = 6;
    ShortPeriodInSeconds: number = 5;
    LongPeriodInSeconds: number = 30;
};
export type AttachmentLimit = number;

export var LookupData: {
        Priority: ["high", "medium", "low", "ultraHigh"],
        Status: ["open", "closed", "inProgress", "rework", "waitingForUat", "readyForUat", "finished"],
        CaseType: ["bug", "request", "support"],
        Severity: ["level1", "level2", "level3", "level4"],
        Impact: ["low", "medium", "high"],
        Environment: ["dev", "test", "uat", "prod"]
}

